module.exports = __webpack_public_path__ + "img/products_big_can_sugar.6a10f2f3.png";